import { Suspense } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import Container from '@mui/material/Container';
import * as Sentry from '@sentry/react';
import Footer from 'components/Layout/Footer';
import Loader from 'components/Layout/Loader';
import { User } from 'data/models/user.interface';
import Error404 from 'pages/Error/404';
import { getUserRoutes } from 'plugins/router';

interface Props {
  user: User;
}

const Router = ({ user }: Props): JSX.Element => {
  const location = useLocation();

  const userRoutes = getUserRoutes(user);
  const SentryRoutes = Sentry.withSentryReactRouterV7Routing(Routes);

  return (
    (user.isAuthenticated && (
      <>
        <Container sx={{ maxWidth: 'calc(100% - 200px) !important' }}>
          <Suspense fallback={<Loader />}>
            <SentryRoutes location={location}>
              <Route
                path="/"
                element={
                  <Navigate
                    to={userRoutes?.filter(({ hidden }) => !hidden)[0].path}
                  />
                }
              />

              {userRoutes.map((navRoute) => (
                <Route
                  key={navRoute.path}
                  path={navRoute.path}
                  element={navRoute.component || <></>}
                />
              ))}
              <Route path="*" element={<Error404 />} />
            </SentryRoutes>
          </Suspense>
        </Container>
        <Footer />
      </>
    )) || <></>
  );
};

export default Router;
